import React from 'react';
import { Shirt } from 'lucide-react';
import StyleSwitcher from './StyleSwitcher';
import ImageUploadBox from './ImageUploadBox';
import TextInputBox from './TextInputBox';
import UserInfoBox from './UserInfoBox';


const App = () => {
  const [currentTheme, setCurrentTheme] = React.useState('theme-1');
  const [imageFile, setImageFile] = React.useState(null);
  const [customText, setCustomText] = React.useState('');
  const [userInfo, setUserInfo] = React.useState({
    height: 180,
    weight: 80,
    build: 'athletic'
  });

  // Function to cycle through themes
  const switchTheme = React.useCallback(() => {
    const themes = ['theme-1', 'theme-2', 'theme-3'];
    const currentIndex = themes.indexOf(currentTheme);
    const nextIndex = (currentIndex + 1) % themes.length;
    setCurrentTheme(themes[nextIndex]);
  }, [currentTheme]);

  // Effect to handle Alt+Q shortcut for theme switching
  React.useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.altKey && event.key === 'q') {
        switchTheme();
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    // Set the theme class on body
    document.body.className = currentTheme;

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [currentTheme, switchTheme]);

  const handleImageUpload = (file) => {
    setImageFile(file);
  };

  const handleTextChange = (text) => {
    setCustomText(text);
  };

  const handleUserInfoChange = (info) => {
    setUserInfo({ ...userInfo, ...info });
  };

  return React.createElement('div', { className: `app-container ${currentTheme}` },
    React.createElement('div', { className: 'content-container' },
      React.createElement('div', { className: 'left-panel' },
        React.createElement('div', { className: 'card animate-fade-in' },
          React.createElement('h1', { className: 'title' }, 'Design Your Custom T-Shirt'),
          React.createElement('p', null, 'Upload your design, add custom text, and get it done!')
        ),
        React.createElement(ImageUploadBox, {
          onImageUpload: handleImageUpload,
          currentImage: imageFile
        }),
        React.createElement(TextInputBox, {
          value: customText,
          onChange: handleTextChange
        })
      ),
      React.createElement('div', { className: 'right-panel' },
        React.createElement(UserInfoBox, {
          userInfo: userInfo,
          onChange: handleUserInfoChange
        }),
        React.createElement('div', { className: 'card animate-fade-in' },
          React.createElement('div', { className: 'subtitle' }, 'Preview'),
          React.createElement('div', {
            className: 'preview-container',
            style: {
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center'
            }
          },
            React.createElement(Shirt, {
              size: 120,
              color: 'currentColor',
              className: 'animate-pulse',
              style: { marginBottom: '16px' }
            }),
            imageFile && React.createElement('p', null, `Image: ${imageFile.name}`),
            customText && React.createElement('p', null, `Text: ${customText}`),
            React.createElement('p', null, `Size: ${userInfo.height}cm / ${userInfo.weight}kg`),
            React.createElement('p', null, `Build: ${userInfo.build}`)
          )
        ),
        React.createElement(StyleSwitcher, {
          currentTheme,
          onThemeChange: switchTheme
        })
      )
    )
  );
};

export default App;
